module.exports = __webpack_public_path__ + "img/project-5.9178a378.jpg";